import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ContractConditions } from '@models/contract-conditions';
import { CONTRACT_START_TOO_EARLY } from '../../../config/error-messages.const';
import { ErrorMessages } from '../../../shared/models/error-messages.model';
import { CommonValidators } from '../../../shared/validators/common-validators';
import { findViableContractStartDate } from '../../../utils/helper.functions';
import { OrderStepBaseComponent } from '../../order-step-base-component';
import { OrderState } from 'app/order/models/order-state.model';

@Component({
    selector: 'app-contract-start-date',
    templateUrl: './contract-start-date.component.html',
    styleUrls: ['./contract-start-date.component.scss'],
    standalone: false,
})
export class ContractStartDateComponent extends OrderStepBaseComponent<Pick<OrderState, 'contract'>> {
    public contractStartError: ErrorMessages = {
        default: null,
        ageTooHigh: CONTRACT_START_TOO_EARLY,
    };

    public constructor(private formBuilder: FormBuilder) {
        super();
        this.initForm();
    }

    public get contract(): Partial<ContractConditions> | undefined {
        return this.state?.contract;
    }

    private initForm(): void {
        this.form = this.formBuilder.group({
            contractStart: [null, CommonValidators.birthday(-1, 0)],
        });
    }

    public handleStateChange(): void {
        if (this.contract?.contractStart) {
            this.form.patchValue({ contractStart: this.contract.contractStart });
        } else {
            this.form.patchValue({
                contractStart: findViableContractStartDate(this.product()?.orderConfig?.contractStartMode),
            });
        }
        if (this.product()?.orderConfig?.contractStartMode === 'month') {
            this.form
                .get('contractStart')
                .setValidators([Validators.required, Validators.pattern(/^([0-9]{2}\.){2}[0-9]{4}$/)]);
        } else {
            this.form.get('contractStart').setValidators(CommonValidators.birthday(-1, 0));
        }
        this.form.get('contractStart').updateValueAndValidity();
    }

    public getData(): Partial<OrderState> {
        return { contract: { ...this.contract, contractStart: this.form.get('contractStart').value } };
    }
}
